import React from "react";
import { Link } from "react-router-dom";
import ProjectsSection from "../../components/ProjectsSection";
import Testimonials from "../../components/Testimonials";

const Ecommerce = () => {

  const projects = [
    {
      title: "Modern E-commerce Store",
      desc: "Complete online store with cart and checkout.",
      link: "https://e-commerce-website-gamma-pied.vercel.app/",
    },
  ];

  const testimonials = [
    {
      name: "Ahmed Khan",
      role: "Store Owner",
      feedback: "Our sales increased after launch.",
    },
  ];

  return (
    <div className="text-white bg-black overflow-hidden">

      {/* 🔥 HERO */}
      <section className="relative min-h-screen flex items-center justify-center text-center px-6">
        <div className="absolute w-[500px] h-[500px] bg-orange-600/30 blur-[120px] rounded-full top-20 left-1/2 -translate-x-1/2"></div>

        <div className="relative z-10 max-w-4xl">
          <h1 className="text-5xl md:text-7xl font-extrabold">
            Build <span className="text-orange-400">High-Converting</span><br />
            Online Stores
          </h1>

          <p className="mt-6 text-gray-300 text-lg max-w-2xl mx-auto">
            We create powerful e-commerce platforms designed to maximize sales and growth.
          </p>

          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <Link to="/contact" className="px-8 py-4 bg-orange-500 rounded-full hover:scale-105 transition">
              Start Your Store
            </Link>

            <a href="https://calendly.com/thelogicwaves/30min" target="_blank" rel="noreferrer"
              className="px-8 py-4 border border-white/20 rounded-full hover:bg-white/10 transition">
              Book a Call
            </a>
          </div>
        </div>
      </section>

      {/* ABOUT */}
      <section className="py-24 text-center max-w-5xl mx-auto px-6">
        <h2 className="text-4xl font-bold mb-6">More Than Just Stores</h2>
        <p className="text-gray-400">
          We build optimized shopping experiences that convert visitors into buyers.
        </p>
      </section>

      {/* WHAT WE BUILD */}
      <section className="py-24 px-6 grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {[
          "Custom Stores",
          "Payment Integration",
          "Cart Systems",
          "Admin Dashboards",
          "Inventory Systems",
          "Conversion Optimization",
        ].map((item, i) => (
          <div key={i} className="bg-white/5 p-6 rounded-xl border border-white/10 hover:scale-105 transition">
            <h3 className="text-orange-400 font-semibold">{item}</h3>
          </div>
        ))}
      </section>

      {/* PROCESS */}
      <section className="py-24 bg-[#0b1a35] text-center">
        <h2 className="text-4xl font-bold mb-12">Our Process</h2>
        <div className="grid md:grid-cols-4 gap-8 max-w-5xl mx-auto">
          {["Plan", "Design", "Develop", "Launch"].map((step, i) => (
            <div key={i}>
              <div className="text-orange-400 text-2xl font-bold">{i+1}</div>
              <p className="text-gray-300">{step}</p>
            </div>
          ))}
        </div>
      </section>

      <ProjectsSection projects={projects} />
      <Testimonials testimonials={testimonials} />

      {/* 🔥 CTA */}
      <section className="py-28 text-center bg-gradient-to-r from-orange-500 to-red-500 px-6">
        <h2 className="text-4xl md:text-5xl font-bold mb-6">
          Launch Your E-commerce Business 🚀
        </h2>

        <Link to="/contact" className="bg-black px-8 py-3 rounded-lg">
          Contact Us
        </Link>
      </section>

    </div>
  );
};

export default Ecommerce;